import { createSlice } from "@reduxjs/toolkit";
import { getTv, addNewTv, updateTv, deleteTv } from "./thunk";
import { readThunkError } from "../thunkError";

export const initialState = {
  tv: [],
  error: {},
};

const tvSlice = createSlice({
  name: "tv",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTv.fulfilled, (state, action) => {
      state.tv = action.payload;
      state.isTvFail = false;
      state.isTvSuccess = true;
    });

    builder.addCase(getTv.rejected, (state, action) => {
      state.error = readThunkError(action);
      state.isTvFail = true;
      state.isTvSuccess = false;
    });

    builder.addCase(addNewTv.fulfilled, (state, action) => {
      state.tv.push(action.payload);
      state.isTvAdd = true;
      state.isTvAddFail = false;
    });

    builder.addCase(addNewTv.rejected, (state, action) => {
      state.error = readThunkError(action);
      state.isTvAdd = false;
      state.isTvAddFail = true;
    });

    builder.addCase(updateTv.fulfilled, (state, action) => {
      state.tv = state.tv.map((tv) =>
        tv._id.toString() === action.payload._id.toString()
          ? { ...tv, ...action.payload }
          : tv
      );
      state.isTvUpdate = true;
      state.isTvUpdateFail = false;
    });

    builder.addCase(updateTv.rejected, (state, action) => {
      state.error = readThunkError(action);
      state.isTvUpdate = false;
      state.isTvUpdateFail = true;
    });

    builder.addCase(deleteTv.fulfilled, (state, action) => {
      state.tv = (state.tv || []).filter(
        (tv) => tv._id.toString() !== action.payload.tv.toString()
      );
      state.isTvDelete = true;
      state.isTvDeleteFail = false;
    });

    builder.addCase(deleteTv.rejected, (state, action) => {
      state.error = readThunkError(action);
      state.isTvDelete = false;
      state.isTvDeleteFail = true;
    });
  },
});

export default tvSlice.reducer;
